/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a chemical formula to compute its molar mass and see how much each element contributes. Supports groups like Ca(OH)2, brackets like K4[Fe(CN)6] and hydrates like CuSO4·5H2O.`)
};

const es_mw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce una fórmula química para calcular su masa molar y ver cuánto aporta cada elemento. Admite grupos como Ca(OH)2, corchetes como K4[Fe(CN)6] e hidratos como CuSO4·5H2O.`)
};

const de_mw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine chemische Formel ein, um ihre molare Masse zu berechnen und zu sehen, wie viel jedes Element dazu beiträgt. Unterstützt Gruppen wie Ca(OH)2, Klammern wie K4[Fe(CN)6] und Hydrate wie CuSO4·5H2O.`)
};

const nl_mw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul een chemische formule in om de molaire massa te berekenen en te zien hoeveel elk element bijdraagt. Ondersteunt groepen zoals Ca(OH)2, haakjes zoals K4[Fe(CN)6] en hydraten zoals CuSO4·5H2O.`)
};

const fr_mw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez une formule chimique pour calculer sa masse molaire et voir la contribution de chaque élément. Prend en charge les groupes comme Ca(OH)2, les crochets comme K4[Fe(CN)6] et les hydrates comme CuSO4·5H2O.`)
};

const it_mw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci una formula chimica per calcolare la sua massa molare e vedere quanto contribuisce ciascun elemento. Supporta gruppi come Ca(OH)2, parentesi quadre come K4[Fe(CN)6] e idrati come CuSO4·5H2O.`)
};

const pt_br2_mw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe uma fórmula química para calcular sua massa molar e ver a contribuição de cada elemento. Suporta grupos como Ca(OH)2, colchetes como K4[Fe(CN)6] e hidratos como CuSO4·5H2O.`)
};

const pt_mw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza uma fórmula química para calcular a sua massa molar e ver a contribuição de cada elemento. Suporta grupos como Ca(OH)2, parênteses retos como K4[Fe(CN)6] e hidratos como CuSO4·5H2O.`)
};

const ja_mw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`化学式を入力してモル質量を計算し、各元素がどれだけ寄与しているかを確認できます。Ca(OH)2のようなグループ、K4[Fe(CN)6]のような角括弧、CuSO4·5H2Oのような水和物にも対応しています。`)
};

const zh_mw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入化学式即可计算其摩尔质量，并查看各元素的贡献。支持 Ca(OH)2 等基团、K4[Fe(CN)6] 等括号，以及 CuSO4·5H2O 等水合物。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mw_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mw_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mw_intro", locale)
	if (locale === "en") return en_mw_intro(inputs)
	if (locale === "es") return es_mw_intro(inputs)
	if (locale === "de") return de_mw_intro(inputs)
	if (locale === "nl") return nl_mw_intro(inputs)
	if (locale === "fr") return fr_mw_intro(inputs)
	if (locale === "it") return it_mw_intro(inputs)
	if (locale === "pt-BR") return pt_br2_mw_intro(inputs)
	if (locale === "pt") return pt_mw_intro(inputs)
	if (locale === "ja") return ja_mw_intro(inputs)
	return zh_mw_intro(inputs)
};